import { Section, Eyebrow, Heading, Cta } from './home-ui';
import Image from '../../../Utils/Image/image-component';

export default function LearningCenter({ data }) {
    if (!data) return null;
    const { eyebrow, titleLine1, titleLine2, paragraph, cta, cards = [] } = data;

    return (
        <Section id="learn" bg="white">
            <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
                <div className="max-w-2xl">
                    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
                    <Heading line1={titleLine1} line2={titleLine2} className="mt-4" />
                    {paragraph && <p className="mt-4 text-lg text-ink-muted">{paragraph}</p>}
                </div>
                {cta && <Cta label={cta.label} href={cta.href} variant="outline" />}
            </div>

            <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {cards.map((g) => (
                    <a key={g.slug || g.title} href={`/guides/${g.slug}`}
                        className="group flex flex-col overflow-hidden rounded-card border border-surface-line bg-white transition hover:border-brand hover:shadow-[0_10px_30px_rgba(11,34,101,0.09)]">
                        <div className="relative">
                            {g.image ? (
                                <Image src={g.image} alt={g.title} useSekeleton objectFit="cover" wrapperClassName="aspect-[8/5] w-full" />
                            ) : (
                                <div className="aspect-[8/5] w-full" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#F2F4F7 0 10px,#E7EAF0 10px 20px)' }} />
                            )}
                            <span className="absolute bottom-2 left-2 rounded-full bg-navy px-2.5 py-1 text-xs font-semibold text-white">{g.category || 'GUIDE'}</span>
                        </div>
                        <div className="flex flex-1 flex-col p-5">
                            <h3 className="font-display text-base font-bold text-navy">{g.title}</h3>
                            <p className="mt-2 flex-1 text-sm text-ink-muted">{g.excerpt}</p>
                            <span className="mt-4 inline-flex items-center gap-1 font-display font-semibold text-brand">
                                Read More <span className="transition group-hover:translate-x-0.5">→</span>
                            </span>
                        </div>
                    </a>
                ))}
            </div>
        </Section>
    );
}
